<template>
  <b-button
    :color="color"
    class="uk-margin-medium-top"
    type="button"
    :name="name"
    :value="name"
    :disabled="isDisabled"
    @click="click"
    >{{ name }}
  </b-button>
</template>

<script>
export default {
  name: 'CommonPagesFormButton',
  props: {
    name: {
      type: String,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'red'
    }
  },
  methods: {
    click() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped></style>
